import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";

/**
 * Slim relocating band shown just above the footer on the homepage.
 * Renter-facing but placed on an owner-first page — this is a soft
 * cross-sell to would-be tenants who might land here first.
 */
export const RelocatingBand = () => (
  <section
    style={{ backgroundColor: "#EDE9E0" }}
    data-nav-theme="light"
    data-testid="home-relocating-band"
  >
    <div className="mx-auto max-w-[1440px] px-6 py-10 md:px-10 md:py-12">
      <Reveal>
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <p
            className="max-w-[60ch] text-[16px] leading-[1.55] md:text-[17px]"
            style={{ color: "#201E1A" }}
          >
            <span className="label-caps mr-3 text-[10px]" style={{ color: "#C89A4E" }}>
              Moving in?
            </span>
            Moving to Edmonton or Calgary? Our Scouts find your neighbourhood
            before you land.
          </p>
          <Link
            to="/relocating"
            className="group inline-flex items-center gap-2"
            style={{ color: "#24382E" }}
            data-testid="home-relocating-band-cta"
          >
            <span className="label-caps text-[12px]">Explore the program</span>
            <ArrowUpRight
              size={16}
              className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            />
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default RelocatingBand;
